import React from 'react';
import styles from './features.module.css'
import { MessageIcon, SuitIcon, ThumbsIcon, TruckIcon } from '../../../../../Svg';

const features = [
    {
        title: 'Trusted Supply',
        description: 'Sourced only from verified and authorized partners.',
        Icon: SuitIcon,
    },
    {
        title: 'On-Time Delivery',
        description: 'Plan, schedule, and receive exactly when you need it.',
        Icon: TruckIcon,
    },
    {
        title: 'Smarter Sourcing',
        description: 'Make faster, informed decisions with intelligent tools.',
        Icon: ThumbsIcon,
    },
    {
        title: 'Expert Support',
        description: 'Real help from people who know procurement.',
        Icon: MessageIcon,
    },
];

const Features = () => {
    return (
        <section className={styles.featuresSection} aria-label="Why choose Electrowiz">
            <div className={styles.featuresContainer}>
                {features.map(({ title, description, Icon }) => (
                    <div key={title} className={styles.featuresCol}>
                        <span className={styles.iconWrap}>
                            <Icon />
                        </span>
                        <div className={styles.featureText}>
                            <span className={styles.featureTitle}>{title}</span>
                            <p>{description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Features
